import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from './modules/core/auth/storage.service';

@Component({
  selector: 'app-autologin',
  template: '', // não precisa de view
})
export class AutologinComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
  ) {
  }

  ngOnInit(): void {
    try {
      // capturar token vindo em ?token=XYZ
      const token = this.route.snapshot.params['token'];
      const decodeBase64: any = JSON.parse(atob(token));
      if (!decodeBase64.token || !decodeBase64.account) {
        throw new Error('Token inválido');
      }
      this.storageService.saveToken(decodeBase64.token, decodeBase64.account);
      //redirecionar para dashboard
      window.location.href = '/cliente';
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
    }
  }
}
